export default __webpack_public_path__ + "a4be868d4f9ea19f346063e7a96b34fe.png";